import { Component, OnInit } from '@angular/core';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { department, interaction, division, user, usermaster } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { bmIncomingDashBoard, bmOutgoingDashBoard, quater, year } from './../../../models/slakpi';
import { BMApiService } from './../../../services/bm.service';
import { UtilityService } from '../../../services/utility.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
declare var google: any;
import html2pdf from 'html2pdf.js';
@Component({
  selector: 'app-bench-mark-outgoing-dashboard',
  templateUrl: './bench-mark-outgoing-dashboard.component.html',
  styleUrls: ['./bench-mark-outgoing-dashboard.component.css']
})
export class BMOutgoingDashboardComponent implements OnInit {

  public selTab: boolean = true;
  public selTab2: boolean = true;
  public selTab3: boolean = true;

  chartOptiondashboardChart: any = {};
  chartOptionconductedMeetingChart: any = {};
  columnDefinitions: Column[];
  columnDefinitions1: Column[];
  columnDefinitions2: Column[];
  columnDefinitions3: Column[];
  gridOptions: GridOption;
  gridOptions1: GridOption;
  gridOptions2: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  angularGrid1: AngularGridInstance;
  angularGrid2: AngularGridInstance;
  reportPrecentageCount: any;
  kpiDashboard_data_chart_report: any;
  dataset: any;
  public isAdmin: boolean = false;
  user: any = {};
  login_UserID: string; // number
  public user_data: any;
  public filterSettings: Object;
  objBMOutgoingDashboardList: any = [];
  public division_data: any;
  public benchMarkYear_data: any;
  public yearData: any;
  public divisionUnofilter?: number = 0;
  public yearfilter?: number = 0;
  public quarterfilter?: number = 0;
  public quarterData: any;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  upcomingVisitDataSet: any;
  initialLoading: boolean = false;
  useryearData: any;

  receivedBMReq: any;
  conductedBMReq: any;
  fullfilledBMReq: any;
  scheduledBMReq: any;
  inprogressMeeting: any;
  pendingReq: any;
  local: any;
  reginal: any;
  international: any;
  InprogressDataSet: any = [];
  PendingDataSet: any = [];
  isloadInprogress: boolean = false;
  isloadPending: boolean = false;
  public selectedDivision: string = '';
  selectedTab: string = "List of Scheduled meetings";
    isPDFExport: boolean=false;
  isLoadScheduled: boolean = true;
  strCurrentYear: any = (new Date()).getFullYear();
    quarterLabel: any;
  constructor(private router: Router, private userService: UserService, public utilityService: UtilityService, public restSLAKPIApi: SLAKPIApiService, public restApi: AdminApiService, public restBMApi: BMApiService, private spinner: SpinnerVisibilityService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.useryearData = this.user.currentYear;
    this.initialLoading = true;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {

    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    // this.CheckUserPermission();
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    //if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam && !this.isBMVisitor && !this.isBMAdmin)
    //  this.router.navigateByUrl('/access-denied');

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Outgoing/internal BM Dashboard");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions1 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid2',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions2 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid3',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions1 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid2',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions2 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid3',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    if (this.isBMChambion) {
      this.divisionUnofilter = (this.user.divisionUno != '') ? parseInt(this.user.divisionUno) : 0;
    }
    //this.getBenchMarkYear();
    this.getDivisions();
    this.loadYear();
    this.loadQuater();
    this.getBMOutgoingDashboardList();


  }

  onChangeTab1(data) {
    if (data == 'In Progress') {
      this.isloadPending = false;
      this.isLoadScheduled = false;
      this.isloadInprogress = true;
      this.columnDefinitions2 = [];
      this.setUpcomingVisitColnDefn2();
      this.selectedTab = "List of In-Progress meetings";
    }
    else if (data == 'Pending') {
      this.isLoadScheduled = false;
      this.isloadPending = true;
      this.isloadInprogress = false;
      this.columnDefinitions3 = [];
      this.setUpcomingVisitColnDefn3();
      this.selectedTab = "List of Pending meetings";
    }
    else {
      this.isLoadScheduled = true;
      this.isloadPending = false;
      this.isloadInprogress = false;
      this.columnDefinitions1 = [];
      this.setUpcomingVisitColnDefn();
      this.selectedTab = "List of Scheduled meetings";
    }
    // this.getBMIncomingDashboardList();

  }

  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;

    this.restBMApi.getQuaterMaster(inpValue)
      .subscribe(data => {

        this.quarterData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  // Get user list
  //loadUserMaster() {
  //  this.spinner.show();
  //  let inpValue = new usermaster();
  //  inpValue.languageUno = 1033;
  //  inpValue.itemUno = 0;
  //  inpValue.condition = 1;
  //  inpValue.userUno = 2;
  //  inpValue.tenantUno = "1";
  //  
  //  this.restApi.getUserMasters(inpValue)
  //    .subscribe(data => {
  //      
  //      this.user_data = data;
  //      const mockDataset = [];
  //      for (let i = 0; i < this.user_data.length; i++) {
  //        mockDataset[i] = {
  //          id: i + 1,
  //          userUno: this.user_data[i].userUno,
  //          ntUsername: this.user_data[i].ntUsername,
  //          displayNameEn: this.user_data[i].displayNameEn,
  //          userPhoto: this.user_data[i].userPhoto,
  //          emailId: this.user_data[i].emailId,
  //          lastLogin: this.user_data[i].lastLogin
  //        };
  //      }
  //      this.dataset = mockDataset;
  //      if (mockDataset.length > 0) {
  //        this.setColnDefn();
  //      }
  //      this.loading = false;
  //      this.spinner.hide();
  //    },
  //      (error) => {
  //        //Called when error
  //        this.spinner.hide();
  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)
  //      this.spinner.hide();
  //    });
  //}
  getBMOutgoingDashboardList() {
    this.loading = true;
    this.columnDefinitions = [];
    let inpValue = new bmOutgoingDashBoard();
    inpValue.organization = '';
    inpValue.division = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.year = this.yearfilter ? this.yearfilter : 0;
    inpValue.quarter = this.quarterfilter ? this.quarterfilter : 0;
    if (this.initialLoading) {
      inpValue.defaultyear = this.user.currentYear;
    }
    else {
      this.useryearData = ""
      inpValue.defaultyear = this.yearfilter
    }
    if (!inpValue.year) {
      
      inpValue.defaultyear = this.user.currentYear;
      this.useryearData = this.user.currentYear;
    }
    inpValue.userUno = this.login_UserID;
    //inpValue.defaultyear = 0;
    
    this.restBMApi.getBMOutgoingDashboard(inpValue)
      .subscribe(data => {
        this.initialLoading = false;
        
        if (data != null) {
          this.objBMOutgoingDashboardList = data[0];
          this.receivedBMReq = this.objBMOutgoingDashboardList.receivedReq[0].receivedReq;
          this.conductedBMReq = this.objBMOutgoingDashboardList.conductedReq[0].conductedReq;
          this.fullfilledBMReq = this.objBMOutgoingDashboardList.fulFilledReq[0].fulFilledReq;
          this.scheduledBMReq = this.objBMOutgoingDashboardList.scheduledMeeting[0].scheduledMeeting;
          this.inprogressMeeting = this.objBMOutgoingDashboardList.inProgressMeeting[0].inProgressMeeting;
          this.pendingReq = this.objBMOutgoingDashboardList.pendingMeeting[0].pendingMeeting;
          this.local = this.objBMOutgoingDashboardList.local[0].local;
          this.reginal = this.objBMOutgoingDashboardList.regional[0].regional;
          this.international = this.objBMOutgoingDashboardList.international[0].international;
          //const mockDataset = [];
          //for (let i = 0; i < this.objBMOutgoingDashboardList.upcomingVisits.length; i++) {

          //  mockDataset[i] = {
          //    id: i + 1,
          //    division: this.objBMOutgoingDashboardList.upcomingVisits[i].division,
          //    organizationName: this.objBMOutgoingDashboardList.upcomingVisits[i].organizationName,
          //    organizationType: this.objBMOutgoingDashboardList.upcomingVisits[i].organizationType,
          //    department: this.objBMOutgoingDashboardList.upcomingVisits[i].department
          //  };

          //}
          //this.dataset = mockDataset;
          //if (mockDataset.length > 0) {
          //  this.setUpcomingVisitColnDefn();
          //}
          //this.loading = false;

          
          var filteredDataScheduled = this.objBMOutgoingDashboardList.upcomingVisitsData.filter(a =>
            a.requestStatus && a.requestStatus.toLowerCase().includes('Scheduled'.toLowerCase()))
          var filteredDataPending = this.objBMOutgoingDashboardList.upcomingVisitsData.filter(a =>
            a.requestStatus && a.requestStatus.toLowerCase().includes('NO Response'.toLowerCase()))
          var filteredDataInprogress = this.objBMOutgoingDashboardList.upcomingVisitsData.filter(a =>
            a.requestStatus && a.requestStatus.toLowerCase().includes('In Progress'.toLowerCase()))
          const mockDataset = [];
          for (let i = 0; i < filteredDataScheduled.length; i++) {

            mockDataset[i] = {
              id: i + 1,
              organizationName: filteredDataScheduled[i].organizationName,
              department: filteredDataScheduled[i].department,
              organizationType: filteredDataScheduled[i].organizationType,
              division: filteredDataScheduled[i].division,
              status: filteredDataScheduled[i].visitRemoteMeetingStatus
            };

          }
          this.upcomingVisitDataSet = mockDataset;
          this.dataset = mockDataset;
          if (mockDataset.length > 0) {
            this.setUpcomingVisitColnDefn();
          }

          const mockDataset2 = [];
          for (let i = 0; i < filteredDataPending.length; i++) {

            mockDataset2[i] = {
              id: i + 1,
              requestFrom: filteredDataPending[i].organizationName,
              requestedTopics: filteredDataPending[i].department,
              organizationType: filteredDataPending[i].organizationType,
              division: filteredDataPending[i].division,
              status: filteredDataPending[i].visitRemoteMeetingStatus
            };

          }
          this.PendingDataSet = mockDataset2;
          if (mockDataset2.length > 0) {
            this.setUpcomingVisitColnDefn3();
          }
          const mockDataset1 = [];
          for (let i = 0; i < filteredDataInprogress.length; i++) {

            mockDataset1[i] = {
              id: i + 1,
              requestFrom: filteredDataInprogress[i].organizationName,
              requestedTopics: filteredDataInprogress[i].department,
              organizationType: filteredDataInprogress[i].organizationType,
              division: filteredDataInprogress[i].division,
              status: filteredDataInprogress[i].visitRemoteMeetingStatus
            };

          }
          this.InprogressDataSet = mockDataset1;
          if (mockDataset1.length > 0) {
            this.setUpcomingVisitColnDefn2();
          }

          if (this.objBMOutgoingDashboardList.summaryofOrganizationType.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.dashboardChart(this.objBMOutgoingDashboardList.summaryofOrganizationType);
              this.spinner.hide();
            }, 200);
          }

          //if (this.objBMOutgoingDashboardList.summaryofIncomingVisits.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //   this.summaryOutcomingChart(this.objBMOutgoingDashboardList.summaryofIncomingVisits);


          //    this.spinner.hide();
          //  }, 200);
          //}

          //if (this.objBMOutgoingDashboardList.summaryofIncomingVisits.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    google.charts.load('current', { 'packages': ['corechart', 'bar'] });
          //    google.charts.setOnLoadCallback(this.visitorSatisfactionChart(this.objBMOutgoingDashboardList.summaryofIncomingVisits));


          //    this.spinner.hide();
          //  }, 600);
          //}

          if (this.objBMOutgoingDashboardList.summaryofConductedMeeting.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.conductedMeetingChart(this.objBMOutgoingDashboardList.summaryofConductedMeeting);


              this.spinner.hide();
            }, 200);
          }



          //if (this.objBMOutgoingDashboardList.summaryofIncomingVisits.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    google.charts.load('current', { 'packages': ['table'] });
          //    google.charts.setOnLoadCallback(this.upcommingVisitChart(this.objBMOutgoingDashboardList.summaryofIncomingVisits));


          //    this.spinner.hide();
          //  }, 900);
          //}

        }

        setTimeout(() => {
          this.spinner.hide();
          this.loading = false;
        }, 1500);
      },
        (error) => {
          this.loading = false;
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }



  dashboardChart = (option_data: any) => {
    

    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //} 

    let tempArray = [];
    let totalValue = 0;
    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //}
    tempArray.push({ name: 'Government', value: option_data[0].noOfGovernment }, { name: 'Private', value: option_data[0].noOfPrivate }, { name: 'Semi Government', value: option_data[0].noOfSemiGovernment });
    totalValue = option_data[0].noOfGovernment + option_data[0].noOfPrivate + option_data[0].noOfSemiGovernment;
    //echarts starts
    this.chartOptiondashboardChart = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "45%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / totalValue) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends

    //const chart = new google.visualization.PieChart(document.getElementById('dashboardChart'));
    //chart.draw(data, options);
  }

  summaryOutcomingChart = (option_data: any) => {

    let tempArray = [];
    tempArray.push(['Quarter', 'Total Approved Received Request', 'Fulfilled Visit', 'Cancelled Request', 'Pending Request In-Progress']);
    //tempArray.push(['2021/Q1', 39, 30, 15, 18]);

    //for (var i = 0; i < option_data.length; i++) {
    //  tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    //}
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].quarter, option_data[i].column1, option_data[i].column2, option_data[i].column3, option_data[i].column4]);
    }
    

    var data = new google.visualization.arrayToDataTable(tempArray);

    //var data = google.visualization.arrayToDataTable([
    //  ['Quarter', 'Total Approved Received Request', 'Fulfilled Visit', 'Cancelled Request', 'Pending Request In-Progress'],
    //  ['2021/Q1', 39, 30, 15, 18],
    //  ['2021/Q2', 29, 20, 65, 48],
    //  ['2021/Q3', 19, 10, 55, 58]

    //]);

    var options = {

      //vAxis: { title: 'Visit Count' },
      hAxis: { title: 'Year', titleTextStyle: { italic: false } },
      seriesType: 'bars',
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: { 5: { type: 'line' } },
      legend: { position: 'bottom' },
      chartArea: { left: 50, top: 50, bottom: 50, right: 50, width: "80%", height: "100%" },
      vAxis: {
        baselineColor: '#999',
        gridlineColor: '#ccc',
        title: 'Visit Count',
        titleTextStyle: { italic: false }
      }
    };

    var chart = new google.visualization.ComboChart(document.getElementById('chart_summaryIn'));
    chart.draw(data, options);

  }

  visitorSatisfactionChart = (option_data: any) => {

    let tempArray = [['Type', 'Quarter', 'Visit Count']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    }
    

    //var data = new google.visualization.arrayToDataTable(tempArray);

    var data = google.visualization.arrayToDataTable([
      ['Quarter', 'Target', 'Actual'],
      ['2021/Q1', 100, 70],
      ['2021/Q2', 100, 90],
      ['2021/Q3', 100, 60]
    ]);

    var options = {

      hAxis: { title: 'Year', titleTextStyle: { color: '#333' } },
      vAxis: { minValue: 0 },
      chartArea: { width: '80%' },
    };

    var chart = new google.visualization.AreaChart(document.getElementById('chart_VisitorSatisification'));
    chart.draw(data, options);

  }
  visitperDivisionChart = (option_data: any) => {

    let tempArray = [['Type', 'Quarter', 'Visit Count']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    }
    

    //var data = new google.visualization.arrayToDataTable(tempArray);

    var data = google.visualization.arrayToDataTable([
      ['Division', 'VisitCount', 'Performance'],
      ['Test Division1', 10, 24],
      ['Test Division2', 16, 22],
      ['Test Division3', 28, 19]
    ]);

    var options = {

      legend: {
        position: 'bottom',
        maxLines: 3
      },
      bar: {
        groupWidth: '25%'
      },
      isStacked: true,
      chartArea: { width: '80%' },
    };
    var chart = new google.visualization.BarChart(document.getElementById('chart_summaryIn_division'));
    chart.draw(data, options);

  }

  upcommingVisitChart = (option_data: any) => {

    let tempArray = [['Type', 'Quarter', 'Visit Count']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    }
    

    //var data = new google.visualization.arrayToDataTable(tempArray);

    var data = new google.visualization.DataTable();
    data.addColumn('string', 'Request From');
    data.addColumn('string', 'Request Topic');
    data.addColumn('string', 'Organisation Type');
    data.addRows([
      ['Dubai Police', 'service level', 'Government'],
      ['Emirates Global Aluminum', 'General Tpoic', 'Private'],
      ['Dubai Government Workshop', 'General Tpoic', 'Government'],
      ['Smart Dubai', 'General Tpoic', 'Government']
    ]);

    var table = new google.visualization.Table(document.getElementById('chart_upcommingVisit'));

    table.draw(data, { showRowNumber: true, width: '100%', height: '100%' });

  }


  conductedMeetingChart = (option_data: any) => {
    


    let tempArray = [];
    let tempArray_Year = [];
    let tempArray_Happiness = [];
    for (var i = 0; i < option_data.length; i++) {
      if (parseInt(option_data[i].noofMeeting) > 0) {
        tempArray_Happiness.push(parseInt(option_data[i].noofMeeting));
        tempArray_Year.push(option_data[i].year)
      }
    }
    tempArray.push({ name: "No of Meeting", type: 'bar', data: tempArray_Happiness, label: { show: true, position: 'top' }  });

    //echarts starts
    this.chartOptionconductedMeetingChart = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      toolbox: {
        feature: {

          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      //legend: {
      //  data: ['No of Meeting'],
      //  bottom: '0',
      //  left: 'center',
      //  //padding: [
      //  //  20,  // up
      //  //  0, // right
      //  //  0,  // down
      //  //  0, // left
      //  //],
      //},
      barWidth: "20%",
      xAxis: {
        name: 'Year',
        nameLocation: 'middle',
        nameGap: 40,
        type: 'category',
        data: tempArray_Year
      },
      yAxis: {
        name: 'No of Meeting',
        nameLocation: 'middle',
        nameGap: 35,
        type: 'value'
      },
      series: tempArray

    };
    // echarts ends
    //const chart = new google.visualization.ComboChart(document.getElementById('conductedMeetingChart'));
    //chart.draw(data, options);
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }

  onChangeFilter(Value:any) {

    
    let temp = this;
    
    if (this.quarterfilter != null && this.quarterfilter != undefined) {
      if (Value.length > 0) {
        this.quarterLabel = " - " + Value[0].text;
      }
      else {
        this.quarterLabel = "";
      }
      
    }
    this.spinner.show();
    setTimeout(function () {
      if (temp.quarterfilter != null && temp.quarterfilter != undefined) {
        if (Value.length > 0) {
          temp.quarterLabel = " - " + Value[0].text;
        }
        else {
          temp.quarterLabel = "";
        }

      }
      else {
        temp.quarterLabel = "";
      }
      temp.getBMOutgoingDashboardList();
    }, 1000);
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  nameFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return '<div class="e-image"><img class="e-avatar" src="' + dataContext.userPhoto + '" alt="user"></div><span class="name"> ' + dataContext.displayNameEn + '</span>';
  };

  setUpcomingVisitColnDefn3() {
    let temp = this;
    this.columnDefinitions3 = [
      {
        id: 'requestFrom', name: 'Organization Name', field: 'requestFrom', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestedTopics', name: 'Department', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Divison', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  setUpcomingVisitColnDefn2() {
    let temp = this;
    this.columnDefinitions2 = [
      {
        id: 'requestFrom', name: 'Organization Name', field: 'requestFrom', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },


      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestedTopics', name: 'Department', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Divison', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  setUpcomingVisitColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'organizationName', name: 'Organization Name', field: 'organizationName', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationName', 'organizationName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'department', name: 'Department', field: 'department', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'department', 'department'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Divison', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }


  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  angularGridReady1(angularGrid: AngularGridInstance) {
    this.angularGrid1 = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularGridReady2(angularGrid: AngularGridInstance) {
    this.angularGrid2 = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  sentenceCase(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    return str.replace(/\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() +
          txt.substr(1).toLowerCase();
      });
  }

  exportToPDF() {
    //this.loading = true;
    var temp = this;
    this.isPDFExport = true;
    //var hd = document.getElementById('divHeader');
    //hd.style.display = 'none';
    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    


    data = document.getElementById('divOutgoingSection');


    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      filename: 'BM Outgoing Summary_' + strDate + '.pdf',
      //filename: 'Report.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'landscape' }

    };

    // New Promise-based usage:
    //html2pdf().from(data).set(opt).save();
    //hd.style.display = 'block';

    setTimeout(() => {
      //this.loading = false;
      html2pdf().from(data).set(opt).save();
      this.isPDFExport = false;
      temp.spinner.hide();
    }, 300)
  }
}
